import React from "react";
import { Grid, Button, CircularProgress } from "@material-ui/core";
import { inject, observer } from "mobx-react";
import SubsheetPopup from "./SubsheetPopup";
import { useFormikContext } from "formik";

function SubsheetColumnConfig(props) {
  const { values, store, setFieldValue } = props;
  const { handleSubmit: submitForm } = useFormikContext();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isLoading, setLoading] = React.useState(false);

  return (
    <>
      <Grid item xs={12}>
        Click Revise to Add/Edit Subsheet Fields
      </Grid>
      <Grid item xs={12}>
        <Button
          onClick={async (e) => {
            const target = e.target;
            if (!values.column_name) {
              return Ext.Msg.alert("Error", "Please enter column name");
            }
            if (!values.options.sub_list_id) {
              setLoading(true);
              const subListId = await store.createList(values.column_name);
              setLoading(false);
              if (!subListId) {
                return;
              }
              setFieldValue("options.sub_list_id", subListId);
            }

            setAnchorEl(target);
          }}
          disabled={isLoading}
          variant="outlined"
        >
          Revise
          {isLoading && <CircularProgress size={18} />}
        </Button>
        <SubsheetPopup
          isOpen={Boolean(anchorEl)}
          store={store}
          values={values}
          onClose={() => setAnchorEl(null)}
          onSave={(options) => {
            setAnchorEl(null);
            setTimeout(() => {
              if (values.list_columns.length > 0) {
                submitForm();
              }
            }, 100);
          }}
          columnName={values.column_name}
          setFieldValue={setFieldValue}
        />
      </Grid>
    </>
  );
}

export default inject(({ store: appStore }) => ({
  // store: appStore.addColumnStore,
  //   validateExpressionFormula: appStore.addColumnStore.validateExpressionFormula,
}))(observer(SubsheetColumnConfig));
